module.exports = __webpack_public_path__ + "img/switch-camera.129e7f15.svg";